
<div class="image h-[100%] w-[100%] p-[2rem]">
  <app-image
    [loaderTheme]="{
               'height': '100%',
               'width': '100%'
              }"
    [url]="'/assets/images/png/pageNotFound.png'"
    class="image-container "
  ></app-image>
</div>

